module.exports = __webpack_public_path__ + "img/ring_g_c_1_1@3x.697c4959.png";